module.exports = __webpack_public_path__ + "media/dashboard/assets/images/logo_thumbnail-aa774257ed361c0c80da60b941dac072.svg";